
        <ng-content></ng-content>
    


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/grid/column/column.component.ts.ColumnComponent.html